import React from 'react';
import { Modal, Button, Form, Divider } from 'antd';
import { _success, _setAxios } from '../../../../lib/Helper';
import { SelectBiaya, SelectTahunAjaran } from '../../../../components/select';

class Export extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            values: {},
        };
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        this.setState({
            values: values,
        });
    }

    handleSubmit = () => {
        this.setState({
            loading: true
        });
        _setAxios("keuangan/pemasukan/biaya-opsional/ekspor", "POST", this.state.values).then(resp => {
            if (resp.status === true) {
                this.props.hideModal()
                _success('topRight', 'Success', resp.data.message)
                setTimeout(function () {
                    window.location.href = resp.data.data.link;
                }, 1000);
            }
            this.setState({
                loading: false
            });
        })
    };

    render() {

        return (
            <Modal
                title="Export data biaya opsional"
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                footer={<>
                    <Button onClick={this.props.hideModal}>Batal</Button>
                    <Button type="primary" htmlType="submit" onClick={this.handleSubmit} loading={this.state.loading}>Export</Button>
                </>}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item label="Tahun Ajaran">
                        <SelectTahunAjaran
                            onChange={(val) => {
                                this.handleChangeSetValue("tahun_ajaran", val ? val : null)
                            }}
                        />
                    </Form.Item>
                    <Form.Item label="Biaya">
                        <SelectBiaya
                            tahunAjaranId={this.state.values.tahun_ajaran ? this.state.values.tahun_ajaran : ""}
                            onChange={(val) => {
                                this.handleChangeSetValue("pemasukan_detail_id", val ? val : null)
                            }}
                        />
                    </Form.Item>
                    <Divider />
                    <div style={{ textAlign: "left" }}>Data yang diekspor akan langsung diunduh tanpa melalui log export. Apakah Anda yakin?</div>
                </Form>
            </Modal>
        )
    }
}

export default Export;
